import React from 'react'
import PropTypes from 'prop-types'

const Loading = ({ message }) => (
  <div className="cmwf--loading">{message}</div>
)

Loading.propTypes = {
  message: PropTypes.string.isRequired,
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/loading.jsx